import { gql } from '@/__generated__';

const GET_MONITORED_TARGET_BAR_CHART = gql(`#graphql
  query GetMonitoredTargetBarChart($integrationId: Int!, $input: WriteExecutionLogsGroupedIssuesInput) {
    integration(input: { id: $integrationId }) {
      id
      writeExecutionLogGroupedIssues(input: $input ) {
         id
        pageInfo {
          totalCount
        }
        items {
          code
          day
          updatedAt
        }
      }
    }
  }
`);

export default GET_MONITORED_TARGET_BAR_CHART;
